module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caryn Yacowitz, Ju Hong Chen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Author and playwright Caryn Yacowitz earned an MA in creative writing from San Francisco State University. She publishes poetry and non-fiction work for children on various subjects and teaches writing in northern California. ")]), _c('P', [_vm._v(" Ju-Hong Chen is a self-taught artist who grew up in Communist China. Purposely avoiding the training of China's art schools, he worked as an art designer in a factory. He moved to the United States in 1982 and his first picture book earned Parents' Choice Honor Book for illustration. Chen lives in Oregon. ")]), _c('P', [_vm._v("   ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/d21ZZK/tc-custom/9781455606511.jpg?1705319558079",
      "alt": "This image is the cover for the book Jade Stone"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jade Stone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("“A tale of artistic integrity told with artful simplicity.”")])]), _c('br'), _vm._v("                                        — Kirkus Starred Review ")]), _c('p', [_c('b', [_c('i', [_vm._v("“Visually it advances like the unrolling of an oriental scroll . . . A satisfying tale, whether read aloud or pored over alone to pick up the whimsical humor of the illustrations.”    ")])]), _c('br'), _vm._v(" —School Library Journal ")]), _c('p', [_vm._v(" When Chan is given a perfect jade stone and is commanded to carve a dragon from it, he senses a different destiny for the gem—and for himself. Perfect for middle readers and warmly illustrated by painter Ju-Hong Chen, this Chinese folktale offers a clear and gentle message of artistic truth and a lesson in staying true to one’s self. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0